import { Button, ButtonProps, Spinner } from "@fluentui/react-components";
import React from "react";

type LoadingButtonProps = ButtonProps & {
    isLoading: boolean,
    message?: string,
    /**
    * The size of the spinner.
    * @default 'small'
    */
    spinnerSize?: 'tiny' | 'extra-small' | 'small' | 'medium' | 'large' | 'extra-large' | 'huge',

}

export const LoadingButton: React.FC<LoadingButtonProps> = (props) => {

    const [spinnerSize, setSpinnerSize] = React.useState<"tiny" | "extra-small" | "small" | "medium" | "large" | "extra-large" | "huge">("tiny");
    const [loadingMessage, setLoadingMessage] = React.useState<string>();

    React.useEffect(() => {
        if (props.spinnerSize) {
            setSpinnerSize(props.spinnerSize);
        } else {
            setSpinnerSize("tiny");
        }
    }, [props.spinnerSize]);


    React.useEffect(() => {
        setLoadingMessage(props.message);
    }, [props.message]);

    return <Button {...props}
        icon={props.isLoading ?
            <Spinner size={spinnerSize} label={loadingMessage}>
            </Spinner> : null}
        disabled={props.isLoading || props.disabled}>
        {props.children}
    </Button>

}